import {format, subYears} from 'date-fns';
import {makeGetHealthAppointmentsHistory} from 'main/factories/usecases';
import {DateFormatEnum} from 'presentation/constants';
import {formatDateString, sortBookedByDate} from 'presentation/utils';
import normalizeDate from 'presentation/utils/normalizeDate/normalizeDate';
import {formatUtcDate} from 'presentation/utils/convertDate';
import {AppointmentHistoryStatusEnum} from '../../constants/appointmentHistoryStatusEnum';

export const getHealthAppointmentsHistory = async (signal?: AbortSignal) => {
	const formatedToday = format(new Date(), DateFormatEnum.DATE_FORMAT_4);
	const formatedLastYear = format(subYears(new Date(), 1), DateFormatEnum.DATE_FORMAT_4);

	const response = await makeGetHealthAppointmentsHistory().get({
		initial_date: formatedLastYear,
		end_date: formatedToday,
		status: AppointmentHistoryStatusEnum.CONCLUDED,
		signal,
	});

	if (response.content === null) {
		return [];
	}

	const sortedAppointmentsHistory = sortBookedByDate({
		list: response.content,
		type: 'history',
		order: 'asc',
	});

	const formattedAppointmentsHistory = sortedAppointmentsHistory.map(item => {
		const normalizedDate = normalizeDate(item.date);

		return {
			...item,
			date: formatDateString(
				formatUtcDate(normalizedDate),
				DateFormatEnum.DATE_FORMAT_9,
				'dd/MM/yyyy - HH:mm',
			),
		};
	});

	return formattedAppointmentsHistory;
};
